import { render } from "./FunctionOverviewPage.vue?vue&type=template&id=2462bcc4"
import script from "./FunctionOverviewPage.vue?vue&type=script&lang=js"
export * from "./FunctionOverviewPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__